import React, { useState } from 'react'
import { FiPlusCircle } from 'react-icons/fi'
import { useDispatch } from 'react-redux'
import { createArticle, getIssueById } from '../../../../entity/volumes/Volumes'
import CreateArticleModal from '../../../../components/CreateArticleModal/CreateArticleModal'

const CreateArticle = ({ issueId }) => {
  const dispatch = useDispatch()
  const [isOpen, setIsOpen] = useState(false)

  const modalHandler = () => {
    setIsOpen(prev => !prev)
  }

  const createArticleHandler = async data => {
    if (issueId && data) {
      await dispatch(createArticle({ issueId, articleData: data }))

      dispatch(getIssueById(issueId))
    }
    modalHandler()
  }

  return (
    <>
      <FiPlusCircle
        className='opacity-0 group-hover:opacity-100 my-2 text-2xl hover:scale-110 transition-all cursor-pointer text-[#326383]'
        onClick={modalHandler}
      />
      {isOpen && (
        <CreateArticleModal
          isOpen={isOpen}
          onClose={modalHandler}
          onSubmit={createArticleHandler}
        />
      )}
    </>
  )
}

export default CreateArticle
